<template>
	<div class="swiper-core-wrapper">
		<swiper :options="swiperOptions" ref="swiperRef" style="height: 100%">
			<swiper-slide v-for="(chunk, index) in chunks" :key="index">
				<slot :chunk="chunk" :index="index" />
			</swiper-slide>
		</swiper>
		<div v-if="chunks.length > 1" class="swiper-stepper-wrapper">
			<div v-if="currentIndex > 0" class="swiper-stepper swiper-stepper--left" @click="slidePrev">
				<SvgIcons name="right-light" class="swiper-stepper-icon swiper-stepper-icon--left" />
			</div>
			<div
				v-else-if="currentIndex != chunks.length - 1"
				class="swiper-stepper swiper-stepper--right"
				@click="slideNext"
			>
				<SvgIcons name="right-light" class="swiper-stepper-icon" />
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'SwiperCore'
};
</script>

<script setup>
import { ref, computed } from 'vue';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';

defineProps({
	chunks: {
		type: Array,
		default: () => []
	}
});

const currentIndex = ref(0);
const swiperRef = ref();
const swiperOptions = {
	// 禁用触摸滑动
	allowTouchMove: false,

	on: {
		slideChange: () => {
			currentIndex.value = getSwiper.value?.realIndex;
		}
	}
};
const getSwiper = computed(() => swiperRef.value?.$swiper);

// Swiper 导航方法
const slidePrev = () => {
	getSwiper.value?.slidePrev();
};

const slideNext = () => {
	getSwiper.value?.slideNext();
};

// 切换到指定索引
const slideTo = index => {
	getSwiper.value?.slideTo(index);
};

// 暴露方法和属性给父组件
defineExpose({
	slidePrev,
	slideNext,
	slideTo,
	activeIndex: currentIndex
});
</script>

<style lang="less" scoped>
.swiper-core-wrapper {
	height: 100%;
	position: relative;

	.swiper-stepper-wrapper {
		.swiper-stepper {
			position: absolute;
			top: 0;
			bottom: 0;
			z-index: 10;
			margin: auto;
			display: flex;
			align-items: center;
			justify-content: center;

			width: 24px;
			height: 24px;
			background-color: #fff;
			border: 1px solid #e5e6eb;
			border-radius: 50%;
			box-shadow: 1px 4px 16px rgba(0, 0, 0, 0.04);
			backdrop-filter: blur(7px);
			cursor: pointer;

			&:hover {
				border-color: var(--theme-color);

				.swiper-stepper-icon {
					color: var(--theme-color) !important;
				}
			}

			&--left {
				left: -24px;
			}

			&--right {
				right: -24px;
			}
		}

		.swiper-stepper-icon {
			font-size: 16px;
			color: #666 !important;

			&--left {
				transform: rotate(180deg);
			}
		}
	}
}
</style>
